import React from 'react'
import { NavDropDownItem, NavDropDownWrapper } from './atoms'
import { Link } from 'gatsby'
import { showNewsList } from '../../constants'
import { LOCALE } from '@foxrenderfarm/internals'

const aArr = ['news', 'jsFaqs']

export const NavDropDown = ({
  item,
  currentLocale,
  currentPathname,
}: {
  currentLocale: LOCALE
  item: {
    name: string
    key: string
    children: { to: string; key: string; name: string; useGatsbyLink: boolean }[]
    to?: string
    useGatsbyLink?: boolean
  }
  currentPathname: string
}) => {
  const pathnames = item.children.map((item) => ({ key: item.key, url: item.to }))

  const isActive = (url: string, key?: string) => {
    return key === 'news'
      ? currentPathname.includes('news/main')
      : currentLocale === 'en'
        ? url === currentPathname || `/en${url}` === currentPathname
        : currentPathname === `/${currentLocale}${url}`
  }

  return (
    <NavDropDownWrapper
      key={item.key}
      $isActive={pathnames.some((pathItem) => isActive(pathItem.url, pathItem.key))}
      $left={0}
    >
      {item.name}
      <div className='navDropDown'>
        {item.children.map((childrenItem) =>
          childrenItem.key === 'news' && !showNewsList.includes(currentLocale) ? null : (
            <NavDropDownItem
              as={aArr.includes(childrenItem.key) || !childrenItem.useGatsbyLink ? 'a' : Link}
              key={childrenItem.key}
              href={childrenItem.to}
              to={currentLocale === 'en' ? childrenItem.to : `/${currentLocale}${childrenItem.to}`}
              $isActive={isActive(childrenItem.to, childrenItem.key)}
            >
              {childrenItem.name}
            </NavDropDownItem>
          ),
        )}
      </div>
    </NavDropDownWrapper>
  )
}
